var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard md-layout md-size-80 md-small-size-90" },
    [
      !_vm.isSubFull
        ? _c("portfolio-widget", {
            staticClass: "md-layout-item",
            attrs: {
              currentAsset: _vm.currentToken,
              accountState: _vm.accountState,
              tronSum: _vm.sumTron,
              subwallets: _vm.subwalletsFiltered
            },
            on: {
              setSubFull: _vm.setSubFull,
              "asset-change": _vm.setCurrentAsset,
              toggleAdd: _vm.toggleAdd,
              setActiveSubwallet: _vm.setActiveSubwallet
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isSubFull
        ? _c("sub-wallets-widget", {
            attrs: {
              accountBalances: _vm.accountBalances,
              currentAsset: _vm.currentToken,
              subwallets: _vm.subwallets,
              filtered: _vm.subwalletsFiltered
            },
            on: {
              setSubFull: _vm.setSubFull,
              setActiveSubwallet: _vm.setActiveSubwallet,
              toggleAdd: _vm.toggleAdd
            }
          })
        : _c("info-widget", {
            staticClass: "md-layout-item",
            attrs: {
              currentAsset: _vm.currentToken,
              accountState: _vm.accountState
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f797000", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f797000","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/dashboard/index/Dashboard.Index.vue
// module id = PD+X
// module chunks = 1